import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_COUNTRIES_INIT_ACTION,
  FETCH_COUNTRIES_SUCCESS_ACTION,
  FETCH_COUNTRIES_FAIL_ACTION,
  ADD_COUNTRIES_INIT_ACTION,
  ADD_COUNTRIES_SUCCESS_ACTION,
  ADD_COUNTRIES_FAIL_ACTION,
  DELETE_COUNTRIES_INIT_ACTION,
  DELETE_COUNTRIES_SUCCESS_ACTION,
  DELETE_COUNTRIES_FAIL_ACTION,
  EDIT_COUNTRIES_INIT_ACTION,
  EDIT_COUNTRIES_SUCCESS_ACTION,
  EDIT_COUNTRIES_FAIL_ACTION
} from "./action";
//import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//var btoa = require("Base64").btoa;
//var history = createBrowserHistory();

function* fetchcountries(value) {
  // console.log("country fetching");
  let pageno = value.value === undefined ? 1 : value.value;

  const token = localStorage.getItem("token");
  // console.log(token);
  try {
    const res = yield fetch(`${appConfig.ip}/country?limit=10&page=` + pageno, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_COUNTRIES_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_COUNTRIES_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* addcountries(value) {
  // console.log(value);
  try {
    const token = localStorage.getItem("token");
    // console.log(token);

    const data = {
      name: value.value.name,
      isoName: value.value.isoName,
      iso3Name: value.value.iso3Name,
      niceName: value.value.niceName,
      callingCode: value.value.callingCode,
      isActive: value.value.isActive
    };

    const res = yield fetch(`${appConfig.ip}/country`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();
      yield put({ type: FETCH_COUNTRIES_INIT_ACTION });
      yield put({
        type: ADD_COUNTRIES_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Country added successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ADD_COUNTRIES_FAIL_ACTION,
        error: err
      });
    }
  }
}

function* deletecountries(value) {
  let id = value.value;

  // let data = {
  //   isActive: false,
  // };

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/country/` + id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify()
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: FETCH_COUNTRIES_INIT_ACTION });
      yield toast.success("Deleted successfully", {
        autoClose: 3000
      });
      const resJSON = yield res.json();
      yield put({
        type: DELETE_COUNTRIES_SUCCESS_ACTION
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: DELETE_COUNTRIES_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* editcountries(value) {
  try {
    const token = localStorage.getItem("token");

    const data = {
      name: value.value.name,
      isoName: value.value.isoName,
      iso3Name: value.value.iso3Name,
      niceName: value.value.niceName,
      callingCode: value.value.callingCode
      // isActive: value.value.isActive,
    };

    const res = yield fetch(`${appConfig.ip}/country/` + value.value.id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();
      yield put({ type: FETCH_COUNTRIES_INIT_ACTION });
      yield put({
        type: EDIT_COUNTRIES_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Country updated successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: EDIT_COUNTRIES_FAIL_ACTION,
        error: err
      });
    }
  }
}

export function* countryActionWatcher() {
  yield takeEvery(FETCH_COUNTRIES_INIT_ACTION, fetchcountries);
  yield takeEvery(ADD_COUNTRIES_INIT_ACTION, addcountries);
  yield takeEvery(DELETE_COUNTRIES_INIT_ACTION, deletecountries);
  yield takeEvery(EDIT_COUNTRIES_INIT_ACTION, editcountries);
}
